import React from 'react';
import { collection, doc, query, where, getDocs, setDoc } from 'firebase/firestore';
import { firestore } from '../../../../config/firebase';
import { Button, Col, Form, Input, Modal, Row, Space, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { useEffect, useState } from 'react';
const initialState = { question: "", options: [], correctAnswer: '' }
export default function AdminQuiz() {
  const [state, setState] = useState(initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForUpdate, setIsModalOpenForUpdate] = useState(false);
  const [quizesData, setquizesData] = useState([]);


  const truncateStringTo10Words = (inputString) => {
    const words = inputString.split(' ');
    const truncatedString = words.slice(0, 10).join(' ');
    return truncatedString + ' . . . .';
  };
  const deletequiz = async (quiz) => {
    let deletedquiz = { ...quiz, status: "deleted" }
    try {
      await setDoc(doc(firestore, "quizes", deletedquiz.quizId), deletedquiz);
      let quizesDataAfterDelete = quizesData.filter((quiz) => quiz.quizId !== deletedquiz.quizId)
      setquizesData(quizesDataAfterDelete)
      message.success("The quiz Deleted successfully")
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }
  const handleChange = (e) => {
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
  };

  const addquizToFirestore = async (quizData) => {
    try {
      await setDoc(doc(firestore, 'quizes', quizData.quizId), quizData);
      setquizesData([quizData, ...quizesData]);
      message.success('The quiz Added successfully');
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error adding document: ', error);
    }
  };

  const handleUpdatequiz = async () => {
    const updatedquizesData = quizesData.map((quiz) => {
      if (quiz.quizId === state.quizId) {
        return { ...quiz, ...state };
      }
      return quiz;
    });
    try {
      await setDoc(doc(firestore, 'quizes', state.quizId), state);
      setquizesData(updatedquizesData);
      message.success('The quiz Updated successfully');
      setIsModalOpenForUpdate(false);
    }
    catch (error) {
      console.error('Error updating document: ', error);
    }
  };

  const handleAddquiz = async () => {
    const quizId = Math.random().toString(36).slice(2);
    // await setOptions([optionOne, optionTwo, optionThree, optionFour])
    const quizData = {
      ...state,
      createdAt: new Date().toLocaleString(),
      quizId,
      status: 'active',
      // options
    };
    if (!quizData.options || !quizData.question || !quizData.correctAnswer) {
      message.error('FILL ALL INPUTS');
      return;
    }

    addquizToFirestore(quizData);
  };


  useEffect(() => {
    // Fetch quizes data from Firestore when component mounts
    const getquizesFromFirestore = async () => {
      const q = query(collection(firestore, 'quizes'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setquizesData(array);
    };

    getquizesFromFirestore();
  }, []);
  return (
    <>
      <h1 className=' text-[#fffa8a] pt-24 font-bold text-[48px] text-center italic'>All quizes Table</h1>
      <div className="flex justify-content-center  mt-5">
        <Button

          className="px-10  text-center rounded-2xl mx-auto  hover:rounded-lg"
          style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }} onClick={() => setIsModalOpen(true)}
        >
          Add quiz
        </Button></div>
      <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
        <div className="py-8">
          <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
              <table className="min-w-full leading-normal" >
                <thead>
                  <tr>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Question
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Option One
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Option Two
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Option Three
                    </th>

                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Option Forth
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Correct Option
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {quizesData.map((rowData, index) => (
                    <tr key={index}>
                      <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                        <div className="flex items-center">
                          <div>
                            <p className=" whitespace-no-wrap">{truncateStringTo10Words(rowData.question)}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.options[0]}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.options[1]}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <p className=" whitespace-no-wrap">{rowData.options[2]}</p>
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        {rowData.options[3]}
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        {rowData.correctAnswer}
                      </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <Space>
                          <Tooltip title="Delete" color='red'  ><Button onClick={() => deletequiz(rowData)} danger icon={<DeleteOutlined />} /></Tooltip>
                          <Tooltip title="Edit"  ><Button type="primary" icon={<EditOutlined className='text-[#fffa8a]' onClick={() => {
                            setIsModalOpenForUpdate(true)
                            setState(rowData)
                          }} />} /></Tooltip>
                        </Space>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      );
      <Modal
        title="ADD quiz"
        centered
        open={isModalOpen}
        onOk={handleAddquiz}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpen(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={12}>
              <Form.Item label="Title">
                <Input placeholder='Input your Question' name='question' onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="First Option ">
                <Input placeholder='Enter the First Option' name='optionOne'onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[0] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Second Option ">
                <Input placeholder='Enter the Second Option' name='optionTwo' onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[1] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Third Option">
                <Input placeholder='Enter the Third Option' name='optionThree' onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[2] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Forth Option">
                <Input placeholder='Enter the Forth Option' name='optionFour'onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[3] = e.target.value;
                  setState({ ...state, options: newOptions });
                }}/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Correct Option">
                <Input placeholder='Enter the Correct Option' name='correctAnswer' onChange={handleChange} />
              </Form.Item>
            </Col>

          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleAddquiz} className='mx-auto mt-5 text-center'>Add quiz</Button></div>
        </Form>
      </Modal>
      <Modal
        title="Update quiz"
        centered
        open={isModalOpenForUpdate}
        onOk={handleUpdatequiz}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpenForUpdate(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={12}>
              <Form.Item label="Title">
                <Input placeholder='Input your Question' name='question' value={state.question} onChange={handleChange} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="First Option ">
                <Input placeholder='Enter the First Option' name='optionOne' value={state.options[0]} onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[0] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Second Option ">
                <Input placeholder='Enter the Second Option' name='optionTwo' value={state.options[1]} onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[1] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Third Option">
                <Input placeholder='Enter the Third Option' name='optionThree' value={state.options[2]} onChange={(e) => {
                  const newOptions = [...state.options];
                  newOptions[2] = e.target.value;
                  setState({ ...state, options: newOptions });
                }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Forth Option">
                <Input
                  placeholder="Enter the Forth Option"
                  name="optionFour"
                  value={state.options[3]}
                  onChange={(e) => {
                    const newOptions = [...state.options];
                    newOptions[3] = e.target.value;
                    setState({ ...state, options: newOptions });
                  }}
                />
              </Form.Item>

            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Correct Option">
                <Input placeholder='Enter the Correct Option' name='correctAnswer' value={state.correctAnswer} onChange={handleChange} />
              </Form.Item>
            </Col>

          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleUpdatequiz} className='mx-auto mt-5 text-center'>Update quiz</Button></div>
        </Form>
      </Modal>
    </>
  )
}
